import 'core-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { loadTheme, FontStyle } from '@swiggy-private/dls-web-theme/dist/components';
import Routes from './Routes';
import './index.scss';

loadTheme('base');

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <FontStyle />
        <Routes />
    </BrowserRouter>
);
